import Drift from 'drift-zoom';
import noUiSlider from './../../node_modules/nouislider/distribute/nouislider'
import Swiper from 'swiper'
import common from './../module/common'
import {tns} from 'tiny-slider/src/tiny-slider';

let addClass = (element, className) => {
    common.addClass(element, className);
};

let removeClass = (element, className) => {
    common.removeClass(element, className);
};

if(!$('.main-cont').length){
    //if server page
    $('#vueComponent').css('opacity', '1');
}

let fillPriceFilter = (priceFilter, valueFrom, valueTo) => {
    priceFilter.from = valueFrom ? valueFrom : priceFilter.min;
    priceFilter.to = valueTo ? valueTo : priceFilter.max;
};

let priceSliderInitialized;

let onChangePriceFilter = (values, handle, currentValues) => {
    let priceLowest = document.getElementById('input-lowest');
    let priceHighest = document.getElementById('input-highest');

    currentValues.max = priceHighest.value;
    currentValues.min = priceLowest.value;
    let value = values[handle];
    if (handle) {
        priceHighest.value = Math.round(value);
        currentValues.max = priceHighest.value;
    }
    else {
        priceLowest.value = Math.round(value);
        currentValues.min = priceLowest.value;
    }
};

let priceSliderInit = (component) => {
    let currentValues = {};
    priceSliderInitialized = true;

    component.priceFilter.max = component.priceFilter.max ? component.priceFilter.max : 1;

    if(window.searchData && window.searchData.priceRange && window.searchData.priceRange.length){
        fillPriceFilter(component.priceFilter, window.searchData.priceRange[0].from, window.searchData.priceRange[0].to);
        window.searchData.priceRange = [];
    } else if(component.$store.state.moduleSearch.queryparams){
        fillPriceFilter(component.priceFilter, component.$store.state.moduleSearch.queryparams["priceRange[0][from]"], component.$store.state.moduleSearch.queryparams["priceRange[0][to]"]);
    }

    noUiSlider.create(component.Slider, {
        start: [ component.priceFilter.from, component.priceFilter.to ],
        step: 1,
        connect: true,
        range: {
            'min': component.priceFilter.min,
            'max': component.priceFilter.max
        }
    });

    component.Slider.noUiSlider.on('set', function(values, handle){
        onChangePriceFilter(values, handle, currentValues);
        component.priceFilterRequest(currentValues);
    });

    component.Slider.noUiSlider.on('update', function( values, handle ) {
        onChangePriceFilter(values, handle, currentValues);
    });
};

function getChevronIcons() {
    return [
        "<svg class='icon-chevron-left'><use xlink:href='" + window.env.baseUrl + "/svg/icons.svg#icon-chevron-left'></use></svg>",
        "<svg class='icon-chevron-right'><use xlink:href='" + window.env.baseUrl + "/svg/icons.svg#icon-chevron-right'></use></svg>"
    ];
}

export default {
    scrollTop:() => {
        setTimeout(function () {
            let body = $("html, body");
            body.stop().animate({scrollTop:0}, 500, 'swing');
        }, 1000);
    },
    moveToProductNav:() => {
        let distanceToTop;
        let dataTarget;
        let navArr = [
            '#productomschrijving',
            '#vraag-en-antwoord',
            '#reviews',
            '#aanbevolen-combinaties',
            '#klantenservice'
        ];

        let mq = window.matchMedia( "(max-width: 1024px)" );

        let currentNav = navArr.find(function (nav) {
            return window.location.href.indexOf(nav) !== -1 || window.location.href.indexOf(nav.replace('#', '')) !== -1
        });

        if(currentNav){
            dataTarget = document.querySelector(currentNav);

            if(!mq.matches && (currentNav === "#aanbevolen-combinaties") ){
                distanceToTop =  dataTarget.offsetTop + 200;
            } else {
                distanceToTop =  dataTarget.offsetTop;
            }

            if (dataTarget) {
                $("html, body").animate({ scrollTop: distanceToTop }, 500);
            }
        }
    },
    moveToQuestion:() => {
        let lengthOfParam = '#productQuestion'.length;
        let questionId = window.location.href.substr(window.location.href.indexOf('#productQuestion') + lengthOfParam, window.location.href.length);
        let questionJQ = $(`#${questionId}`);

        $("html, body").animate({ scrollTop: questionJQ[0].offsetTop - 200 }, 1000);
    },
    resetShowMainBlock:(opacity) => {
        let vueComponent = $('#vueComponent');
        let spinner = $('.spinner');
        let footer = $('footer');
        let footerUspbar = $('.footer-uspbar');

        spinner.css('opacity', '1');
        vueComponent.css('opacity', opacity);
        footer.css('opacity', '0');
        footerUspbar.css('opacity', '0');
    },
    showMainBlock:() => {
        let vueComponent = $('#vueComponent');
        let footer = $('footer');
        let footerUspbar = $('.footer-uspbar');
        let spinner = $('.spinner');

        spinner.css('opacity', '0');
        vueComponent.animate({'opacity': '1'}, 1000, '', () => {
            footer.css('opacity', '1');
            footerUspbar.css('opacity', '1');
        });
    },
    priceFilter:(component) => {
        priceSliderInit(component);
    },
    footerHeaderSlider:() => {
       $(document).ready(function () {
         const uspsSliderContainer = document.querySelector('.usps-slider');
         const pageUspbarContainer = document.querySelector('.page-uspbar');

         if (uspsSliderContainer) {
           tns({
             container: '.usps-slider .slides',
             loop: true,
             autoplay: true,
             nav: false,
             controls: false,
             speed: 500,
             onInit: function () {
               removeClass(document.querySelector('.usps-slider'), 'invisible');
             }
           });
         }

         // Page slider
// ----------------------------------------------
         if (pageUspbarContainer) {
           tns({
             container: '.page-uspbar .slides',
             loop: true,
             autoplay: true,
             nav: false,
             controls: false,
             speed: 500,
             onInit: function () {
               removeClass(document.querySelector('.page-uspbar'), 'invisible');
             }
           });
         }

// Footer slider
// ----------------------------------------------
           var uspBottomSlider = tns({
               container: '.footer-uspbar .slides',
               loop: true,
               autoplay: true,
               nav: false,
               controls: false,
               speed: 500,
               onInit: function () {
                   removeClass(document.querySelector('.footer-uspbar'), 'invisible');
               }
           });


       })
   },
    navigation: () => {
        var headerEl = document.querySelector('header');
        var headerH = headerEl.clientHeight;
        var scrollToggle = document.querySelectorAll('.js-scrollTo');
        var anchors = document.querySelectorAll('.anchorMenu ul a')
        var anchorsArray = [];
        var timeoutId;

        var smoothScroll = function (anchor, duration) {
            let floatBuyButton = $('header .floatBuyButton');
            let mq = window.matchMedia( "(max-width: 740px)" );
            let hrOffset = $(anchor).is(':first-of-type') ? -20 : 20;

            floatBuyButton = floatBuyButton[0] ? floatBuyButton[0].clientHeight : 0;
            if (anchor) {
              if (mq.matches) {
                $("html, body").animate({scrollTop: anchor.offsetTop -  headerH * 2}, 1000);
              } else {
                $("html, body").animate({scrollTop: anchor.offsetTop + headerH + floatBuyButton + hrOffset}, 1000);
              }
            }
        };

        // For each smooth scroll link
        [].forEach.call(scrollToggle, function (toggle) {

            // When the smooth scroll link is clicked
            toggle.addEventListener('click', function (e) {

                if(timeoutId){
                    clearTimeout(timeoutId);
                }

                e.preventDefault();

                timeoutId = setTimeout(function () {
                    //setTimeout to forbid endless invokes of theevent
                    // Get anchor link and calculate distance from the top
                    var dataID = toggle.getAttribute('href');
                    var dataTarget = document.querySelector(dataID);
                    var dataSpeed = toggle.getAttribute('data-speed');

                    // If the anchor exists
                    if (dataTarget) {
                        // Scroll to the anchor
                        smoothScroll(dataTarget, dataSpeed || 500);
                    }
                }, 300)

            }, false);
        });

        // Push anchor's hrefs into the array
        for (var i = 0; i < anchors.length; i++) {
            var anchor = anchors[i],
                ahref = anchor.getAttribute('href')
            anchorsArray.push(ahref)
        }

        // Functions to call when user scrolls
        window.onscroll = function () {

            var scrollPosition = window.pageYOffset,
                headerOffset = headerH * 2;

            for (var i = 0; i < anchorsArray.length; i++) {
                // Loop over anchor's href tags and set classes
                if(!document.querySelector(anchorsArray[i])){
                    continue
                }

                var theID = anchorsArray[i],
                    divTop = document.querySelector(theID).offsetTop + headerH,
                    divHeight = document.querySelector(theID).offsetHeight;

                if (scrollPosition >= divTop - 20 && scrollPosition < divTop + divHeight - headerOffset ) {
                    addClass(document.querySelector('.anchorMenu ul a[href="' + theID + '"]'), 'active');
                } else {
                    removeClass(document.querySelector('.anchorMenu ul a[href="' + theID + '"]'), 'active');
                }
            }
        }


        if (window.location.href.indexOf('#') >= 0) {
            let anchor = window.location.href.split('#')[1];
            let el = document.querySelector(`[id='${anchor}']`);
            smoothScroll(el, 1000);
        }
    },
    bannersSlider: () => {
        var heroSliderContainer = document.querySelector('.heroSlider');
        var firstSlide = heroSliderContainer.querySelector('.singleSlide');

        var heroSlider = tns({
            container: 			'.heroSlider .slides',
            mode: 				'gallery',
            controlsText: 		getChevronIcons(),
            loop: 				true,
            autoplay: 			false,
            speed: 				550,
            onInit: function(){
                if(firstSlide.querySelector('video')){
                    firstSlide.querySelector('video').play();
                }
            }
        });
        // function to call before slide changes
        function beforeChange(){
            var curSlide = heroSliderContainer.querySelector('[aria-hidden="false"]');
            if(curSlide.querySelector('video')){
                curSlide.querySelector('video').pause();
            }
        }
        // function to call after slide changes
        function afterChange(){
            // wait a little before aria-hidden attribute to change
            setTimeout(function(){
                var curSlide = heroSliderContainer.querySelector('[aria-hidden="false"]');
                if(curSlide.querySelector('video')){
                    curSlide.querySelector('video').play();
                }
            }, 100);
        }

        if(heroSlider){
            heroSlider.events.on('transitionStart', beforeChange);
            heroSlider.events.on('transitionEnd', afterChange);
        }
    },
    productSliderZoom: (sliders) => {
        sliders.productSliderMain = tns({
            container: 			'#productSlider-main',
            controlsText: 		getChevronIcons(),
            loop: 				true,
            speed: 				500,
            navContainer: 		'#productSlider-control',
            lazyload: 			true,
            onInit: function(){
            }
        });

        sliders.productSliderControl = tns({
            container: 			'#productSlider-control',
            items: 				5,
            controlsText: 		getChevronIcons(),
            loop: 				false,
            speed: 				500,
            onInit: function(){
            }
        });

        let allZoomables = document.querySelectorAll('.imageZoom-wrapper');

        for (let i = 0; i < allZoomables.length; i++) {
            new Drift(allZoomables[i].querySelector('.imageZoom'), {
                paneContainer: allZoomables[i].querySelector('.imageZoom-detail'),
                zoomFactor: 2,
                sourceAttribute: 'data-zoom'
            });
        }
    },
    productSwiper: (sliders) => {
        sliders.productSliderMain = new Swiper('.swiper-main-slider', {
            spaceBetween: 10,
            zoom: true,
            centeredSlides: true,
            roundLengths: true,
            grabCursor: true,
            threshold: 3,
            simulateTouch: false,
            watchSlidesProgress: true
        });
        sliders.productSliderMain.on('slideChange',
            function () {
                let imageCount = this.activeIndex + 1;
                $('#image-number').text(imageCount);
            }
        );
    },
    getVideoLink(video) {
        let link = '';
        if (!isNaN(parseFloat(video)) && isFinite(video)) {
            link = `//player.vimeo.com/video/${video}?title=0&byline=0&portrait=0&color=ff9933`;
        } else if ((typeof video === 'string') && video.substr(0, 2) === 'v:') {
            video = video.replace('v:', '');
            link = `//player.vimeo.com/video/${video}?title=0&byline=0&portrait=0&color=ff9933`;
        } else {
            link = `https://www.youtube.com/embed/${video}?rel=0&wmode=transparent&html5=1`;
        }
        return link;
    }
}
